import { NgModule } from '@angular/core';
import { RouterModule, Routes, InitialNavigation, } from '@angular/router';

import { LoggedGuard } from './guard/logged.guard'
import { AuthGuard } from './guard/auth.guard'
import { ThankYouComponent } from './thank-you/thank-you.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    canActivate: [LoggedGuard]
  },
  {
    path: 'student', loadChildren: () => import('./teacher/teacher.module').then(m => m.TeacherModule),
    canActivate: [AuthGuard],
    data: { role: 'student' }
  },
  // {
  //   path: 'institute', loadChildren: () => import('./institute/institute.module').then(m => m.InstituteModule),
  //   canActivate: [AuthGuard],
  //   data: { role: 'institute' }
  // },

  // {
  //   path: '',
  //   title: 'Homepage',
  //   loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  // },
  // {
  //   path: "user",
  //   loadChildren: () => import('./user/user.module').then(m => m.UserModule),
  //   canActivate: [AuthGuard]

  // },
  
  // {
  //   path: 'school', loadChildren: () => import('./school/school.module').then(m => m.SchoolModule),
  //   canActivate: [AuthGuard]
  // },
  

  // {
  //   path: 'thank-you',
  //   // pathMatch: 'full',
  //   component: ThankYouComponent
  // },

  { 
    path: '**', 
    component: PageNotFoundComponent 
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled' as InitialNavigation,
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

